"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignIn = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var SignIn = function SignIn() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14 0H21.3333C22.8061 0 24 1.19391 24 2.66667V21.3333C24 22.8061 22.8061 24 21.3333 24H14C13.6318 24 13.3333 23.7015 13.3333 23.3333V22C13.3333 21.6318 13.6318 21.3333 14 21.3333H21.3333V2.66667H14C13.6318 2.66667 13.3333 2.36819 13.3333 2V0.666667C13.3333 0.298477 13.6318 0 14 0ZM18.6667 11.7467V12.2533C18.6664 12.5185 18.5609 12.7726 18.3733 12.96L11.52 19.8C11.3948 19.9262 11.2244 19.9972 11.0467 19.9972C10.8689 19.9972 10.6985 19.9262 10.5733 19.8L9.62667 18.8667C9.50046 18.7415 9.42947 18.5711 9.42947 18.3933C9.42947 18.2156 9.50046 18.0452 9.62667 17.92L14.2267 13.3333H0.666667C0.298477 13.3333 0 13.0349 0 12.6667V11.3333C0 10.9651 0.298477 10.6667 0.666667 10.6667H14.2267L9.62667 6.08C9.50125 5.95712 9.43057 5.78892 9.43057 5.61333C9.43057 5.43775 9.50125 5.26955 9.62667 5.14667L10.5733 4.2C10.6985 4.07379 10.8689 4.0028 11.0467 4.0028C11.2244 4.0028 11.3948 4.07379 11.52 4.2L18.3733 11.04C18.5585 11.229 18.6636 11.4821 18.6667 11.7467Z",
    clipRule: "evenodd"
  });
};

exports.SignIn = SignIn;